<template>
  <input type="text" class="time-control" v-model="timeInput" @blur="onBlur" @keyup.enter="onEnter" :key="refresh" @keydown.arrow-down="prevFrame" @keydown.arrow-up="nextFrame"/>
</template>

<script>
export default {
  name: 'timeInput',

  props: {
    currentTime: {
      type: Number,
      default: 0
    },

    frameRate: {
      type: Number,
      default: 25
    }
  },

  data() {
    return {
      refresh: 0
    }
  },
 
  computed: {
    timeInput: {
      get: function () {
        return this.secondsToTimeString(this.currentTime, this.frameRate)
      },

      set: function (timeString) {
        if (this.checkFormat(timeString, /^(\d\d:\d\d:\d\d:\d\d)$/)) {
          const newTime = this.fullTimeStringToSeconds(timeString, this.frameRate)
          this.$emit('timeChange', newTime)
        } else if (this.checkFormat(timeString, /^\d+\.\d{3}$/)) {
          const newTime = this.secondsStringToSeconds(timeString)
          this.$emit('timeChange', newTime)
        }
      }
    }
  },

  methods: {
    onBlur: function (e) {
      this.refreshInput()
    },

    onEnter: function (e) {
      const timeString = e.target.value

      if (this.checkFormat(timeString, /^\d+(\.\d*){0,1}$/)) {
        const newTime = this.secondsStringToSeconds(timeString)
        this.$emit('timeChange', newTime)
      } else {
        this.refreshInput()
      }
    },

    prevFrame: function (e) {
      if (this.currentTime > 0) {
        const newTime = this.currentTime - (1 / this.frameRate)
        this.$emit('timeChange', newTime)
      }
    },

    nextFrame: function (e) {
      const newTime = this.currentTime + (1 / this.frameRate)
      this.$emit('timeChange', newTime)
    },

    refreshInput: function () {
      this.refresh = this.refresh > 0 ? 0 : 1
    },

    secondsToTimeString: function (seconds, frameRate) {
      const secondsString = seconds ? (new Date(seconds * 1000)).toUTCString().match(/(\d\d:\d\d:\d\d)/)[0] : '00:00:00'
      const framesString = (Math.trunc((seconds % 1) * frameRate)).toString() || '00'

      const timeString = secondsString + ':' + (framesString.length < 2 ? '0' + framesString : framesString)

      return timeString || 'hh:mm:ss:ff'
    },

    fullTimeStringToSeconds: function (timeString, frameRate) {
      const splitTime = timeString.split(':')

      const hoursInSeconds = parseFloat(splitTime[0]) * 3600 || 0
      const minutesInSeconds = parseFloat(splitTime[1]) * 60 || 0
      const seconds = parseFloat(splitTime[2]) || 0
      const framesInSeconds = (parseFloat(splitTime[3]) + 1) / frameRate || 0

      const secondsTotal =  hoursInSeconds + minutesInSeconds + seconds + (framesInSeconds - 0.001)

      return secondsTotal
    },

    secondsStringToSeconds: function (timeString) {
      return parseFloat(timeString)
    },

    checkFormat: function (timeString, format) {
      return format.test(timeString)
    }
  }
}
</script>
